class Countries extends Array {}

const countries_api_adapter = countries => {
    return countries;
};

const countries_api_list_adapter = countries => countries.map(countries_api_adapter);

const createCountriesList = (data = []) => {
    const countries = Countries.from(data, countries => createCountries(countries));
    return countries;
};

const countries_view_adapter = countries => {
    return countries;
};

const createCountries = ({
    id = null,
    geom = null,
    di_emp_n = null,
    di_emp_per = null,
    di_gva_me = null,
    di_gva_per = null,
    emp_n = null,
    emp_per = null,
    gva_me = null,
    gva_per = null,
    name = null,
    tii_emp_n = null,
    tii_emp_per = null,
    tii_gva_me = null,
    tii_gva_per = null,
    top5 = null,
    type = null,
} = {}) => {
    const publicApi = {
        id,
        geom,
        di_emp_n,
        di_emp_per,
        di_gva_me,
        di_gva_per,
        emp_n,
        emp_per,
        gva_me,
        gva_per,
        name,
        tii_emp_n,
        tii_emp_per,
        tii_gva_me,
        tii_gva_per,
        top5,
        type,
    };

    return Object.freeze(publicApi);
};

export {
    createCountries,
    createCountriesList,
    countries_api_adapter,
    countries_api_list_adapter,
    countries_view_adapter,
};
